<section class="footer">
    <div class="container mt-0 pb-4">
        <div class="row justify-content-lg-between justify-content-center">
            <div class="col-md-3">
                <div class="footer-content">
                    <img src="../assets/images/logo-small.png" class="logo"/>
                    <p class="footer-paragraph">Here , write the complete address of the Registered office address along with telephone number.</p>
                    <ul class="icons">
                        <li><i class="fab fa-x fa-facebook-f"></i></li>
                        <li><i class="fab fa-x fa-twitter"></i></li>
                        <li><i class="fab fa-x fa-instagram"></i></li>
                        <li><i class="fab fa-x fa-youtube"></i></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-3" *ngFor="let f of footer">
            <h5 class="footer-header">{{f.title}}</h5>
            <ul class="footer-links">
                <li class="footer-link" *ngFor="let i of f.li">
                    {{i}}
                </li>
            </ul>
            </div>
        </div>
    </div>
            <div class="footer-end">
                <div class="container mt-0">
                    <div class="row justify-content-between">
                        <div class="col-md-6">
                <p class="copywright">© Copyright 2021, All Rights Reserved</p>
            </div>
                <div class="col-md-6 text-right">
                    <span class="link">Terms of Service  </span>
                    <span class="link">Privacy Policy </span>
            </div>
        </div>
</div>
    </div>
</section>